exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.common[data-v-30aed523] {\n  width: 100%;\n  border-radius: 5px;\n  height: 2.4em;\n  padding: 1.3em;\n}\n.applied[data-v-30aed523] {\n  background-color: var(--theme-light-pink);\n  color: var(--theme-primary);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30aed523","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/multiplePhonePlan/summaryBox/DiscountMessage.vue
// module id = 739
// module chunks = 0